module.exports = __webpack_public_path__ + "static/img/1_0004.fe15b87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0004.jpg
// module id = rkoK
// module chunks = 0